<script setup lang="ts">
withDefaults(defineProps<{ size?: number; inverted?: boolean }>(), { size: 24 });
</script>

<template>
  <div class="spinner" :class="{ inverted }" :style="{ width: `${size}px`, height: `${size}px` }" />
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";

.spinner {
  position: relative;
  border-radius: 50%;
  background: conic-gradient(from 225deg, colors.$main, transparent 330deg, transparent);
  mask: radial-gradient(farthest-side, transparent calc(100% - 4px), colors.$text calc(100% - 4px));
  animation: spin 1s linear infinite;

  &::before {
    content: "";
    position: absolute;
    top: 17px;
    left: 3px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: colors.$main;
  }

  &.inverted {
    background: conic-gradient(
      from 225deg,
      colors.$border-inverse,
      transparent 330deg,
      transparent
    );

    &::before {
      background: colors.$border-inverse;
    }
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
